export function money(value, currency = 'BRL') {
    value = value || 0;
    value = parseFloat(value);
    if (currency === 'BRL') {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
